import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useReceiveMessage } from '../../context/messageContext';
import { ishiharaPlateImage } from '../../helpers/ishihara';
import { colors, fonts, breakpoints } from '../../ui';

// Patient display for the Colour Vision / Ishihara test: the current plate, full screen on white,
// driven by the clinician's {type:'ishiharaPlate', content:{plateId, index, total, instructions}}.

const Screen = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 24px;
  box-sizing: border-box;
  background: #fff;
  font-family: ${fonts.family};
  color: ${colors.slate[600]};
  text-align: center;
`;

const PlateImg = styled.img`
  width: min(78vw, 68vh);
  aspect-ratio: 1;
  object-fit: contain;
  @media (max-width: ${breakpoints.phone - 1}px) {
    width: min(88vw, 60vh);
  }
`;

const Caption = styled.p`
  margin: 0;
  max-width: 640px;
  font-size: 18px;
  line-height: 1.5;
  font-weight: 600;
  @media (max-width: ${breakpoints.phone - 1}px) {
    font-size: 15px;
  }
`;

const Count = styled.span`
  font-size: 13px;
  color: ${colors.slate[400]};
`;

export const ColourVisionPlateView = ({ plateId, index, total, instructions }) => (
  <Screen data-testid='patient-ishihara'>
    {plateId ? <PlateImg src={ishiharaPlateImage(plateId)} alt='Colour vision plate' /> : null}
    <Caption>{instructions || 'Tell your clinician the number you can see. If you cannot see a number, say so.'}</Caption>
    {total ? <Count>{`Plate ${index + 1} of ${total}`}</Count> : null}
  </Screen>
);

const ColourVisionPlate = () => {
  const message = useReceiveMessage();
  const [plate, setPlate] = useState(() => (message?.type === 'ishiharaPlate' ? message.content : null));

  useEffect(() => {
    if (message?.type === 'ishiharaPlate') setPlate(message.content);
  }, [message]);

  return <ColourVisionPlateView {...(plate || {})} />;
};

export default ColourVisionPlate;
